let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("dOOBy")).then(() => parcelRequire('5c2Lm'));